import React from 'react';
import c from 'classnames';
import { SocialLoginProvider } from '../types';
import useFacebookSignIn from '../hooks/useFacebookSignIn';
import SocialButtonBase from '../SocialButtonBase';
import SocialButtonIconViewBase from '../SocialButtonIconViewBase';
import s from './SocialButtonFacebook.scss';
const SocialButtonFacebook = ({ appId, biData, className, view = 'standard', redirectToJoin = false, redirectToSisu, children, attemptSocialLogin })=>{
    const { signIn } = useFacebookSignIn(appId, (response)=>{
        if (response.authResponse) {
            attemptSocialLogin({
                provider: SocialLoginProvider.Facebook,
                token: response.authResponse.accessToken,
                redirectToJoin,
                redirectToSisu
            });
        }
    });
    const onClick = (e)=>{
        e.preventDefault();
        signIn();
    };
    if (view === 'icon') {
        return /*#__PURE__*/ React.createElement(SocialButtonIconViewBase, {
            className: c(s['root'], s['icon'], className),
            biData: biData,
            onClick: onClick
        });
    }
    return /*#__PURE__*/ React.createElement(SocialButtonBase, {
        className: c(s['root'], className),
        biData: biData,
        onClick: onClick
    }, children);
};
SocialButtonFacebook.displayName = 'SocialButtonFacebook';
export default SocialButtonFacebook;
